import type { IconConfig } from '#types/config/components/icon'

export default {
  paths: [
    ['M4,2 L9,2', 'M5,5 L7.5,2.5'],
    ['M2.5,5 L9,5', 'M2.5,2.5 L7.5,7.5'],
    ['M1,8 L9,8', 'M2.5,7.5 L5,5']
  ]
} satisfies IconConfig['menu']
